module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAuNiIgaGVpZ2h0PSI4Ni4xNDMiIHZpZXdCb3g9IjAgMCAxMjAuNiA4Ni4xNDMiPgogIDxwYXRoIGlkPSJpY29fY2hlY2siIGQ9Ik00Ny4yLDg3LjE0MywxLDQwLjkzOSwxMS45NjQsMjkuOTc1LDQ3LjIsNjQuNDMyLDExMC42MzYsMSwxMjEuNiwxMS45NjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMSkiIGZpbGw9IiMyNjk5ZmEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico_check.svg
// module id = uL0b
// module chunks = 2